import { twMerge } from "tailwind-merge";
import React, { ReactElement } from "react";
import { Card } from "@sellar-io/components";
import {
  SkeletonContainer,
  SkeletonAvatar,
  SkeletonText,
} from "../../../components/skeleton/Skeleton";

export function RequestedOrderContentSkeleton(): ReactElement {
  return (
    <>
      <Card className={twMerge("bg-white", "flex flex-col gap-4 p-4")}>
        <div className="flex justify-end">
          <SkeletonContainer className={""}>
            <SkeletonText className={"h-[25px] w-[10px]"} />
          </SkeletonContainer>
        </div>
        <SkeletonContainer className={"mt-2 flex flex-col items-center gap-4"}>
          <SkeletonAvatar className={"h-[50px] w-[50px]"} />
          <SkeletonText className={"w-[75px]"} />
          <SkeletonText className={"h-[25px] w-[80px]"} />
          <SkeletonText className={"w-[90px]"} />
        </SkeletonContainer>
        <SkeletonContainer className={"mt-4 flex flex-col items-center"}>
          <SkeletonText className={"w-full"} />
          <SkeletonText className={"w-[100px]"} />
        </SkeletonContainer>
        <div className="mt-4 flex flex-col gap-2">
          <SkeletonContainer className={"mt-4 flex flex-row justify-between"}>
            <SkeletonText className={"w-1/2"} />
            <SkeletonText className={"w-[100px]"} />
          </SkeletonContainer>
          <SkeletonContainer className={"mt-4"}>
            <SkeletonText className={"h-[150px] w-full"} />
          </SkeletonContainer>
        </div>
      </Card>
      <SkeletonContainer className={"mt-4 flex flex-col gap-2"}>
        <SkeletonText className={"h-[150px] w-full"} />
        <SkeletonText className={"h-[150px] w-full"} />
        <SkeletonText className={"h-[150px] w-full"} />
        <SkeletonText className={"h-[150px] w-full"} />
      </SkeletonContainer>
    </>
  );
}
